import React from "react";
import { Space, Tooltip } from "antd";
import { GithubOutlined, WechatOutlined, QqOutlined } from "@ant-design/icons";

export default function FooterItem() {
  const githubUrl = "https://github.com/"; // 改成你的
  const wechatId = "保密"; // 改成你的
  const qqId = "保密"; // 改成你的

  return (
    <div className="footer-item" style={{ textAlign: "center" }}>
      <Space size={14} style={{ marginBottom: 6 }}>
        <Tooltip title="GitHub">
          <a
            href={githubUrl}
            target="_blank"
            rel="noreferrer"
            style={{ fontSize: 18 }}
          >
            <GithubOutlined />
          </a>
        </Tooltip>

        <Tooltip title={`微信：${wechatId}`}>
          <span
            style={{ fontSize: 18, cursor: "pointer" }}
            onClick={() => navigator.clipboard?.writeText(wechatId)}
          >
            <WechatOutlined />
          </span>
        </Tooltip>

        <Tooltip title={`QQ：${qqId}`}>
          <span
            style={{ fontSize: 18, cursor: "pointer" }}
            onClick={() => navigator.clipboard?.writeText(qqId)}
          >
            <QqOutlined />
          </span>
        </Tooltip>
      </Space>

      <div>© {new Date().getFullYear()} 近看风景不壮观，人与事皆平平 @惜哉剑气疏</div>
    </div>
  );
}